// Factory function to create field validators with custom max value
export const createFieldValueValidator = maxValue => values => {
  const { formattedValue, floatValue } = values

  if (typeof floatValue === 'number') {
    return floatValue >= 0 && floatValue <= maxValue
  } else {
    return formattedValue === ''
  }
}
